import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-qr-code-view',
    templateUrl: './qr-code-view.component.html',
    styleUrls: ['./qr-code-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-qr-code-view' },
    standalone: false,
})
export class FiQRCodeViewComponent {
    @Input() qrData: string;
    @Input() buttonEnabled: boolean = true;
    @Input() showCode: boolean = false;
    @Input() qrCodeWidth: number = 116;
    @Input() isQrcodeTextShown: boolean = true;
    @Output() showCodeChange = new EventEmitter<boolean>();

    toggleShowCode() {
        this.showCode = !this.showCode;
        this.showCodeChange.emit(this.showCode);
    }

    getButtonTextId() {
        return this.showCode ? 'qr_common.hide_code' : 'qr_common.show_code'; // 'Hide code' : 'Show code';
    }
}
